module.exports = __webpack_public_path__ + "static/media/media-landscape.e94b2233.jpg";